export const formLabel = (defaultTheme) => {
    const { breakpoints, typography: { pxToRem } } = defaultTheme
    defaultTheme = {
        ...defaultTheme,
        overrides: {
            MuiFormLabel: {
                root: {
                    fontSize: pxToRem(14),
                    [breakpoints.down("sm")]: {
                        fontSize: pxToRem(10)
                    }
                }
            }
        }
    }

    return defaultTheme;
}